module.exports = __webpack_public_path__ + "img/tv-order.41f9cdf2.webp";